(function(root) {
  const flawlessHandle = 'flawless-facial-hair-remover-finishing-touch';
  function discountFor(handle, quantity) {
    if (handle !== flawlessHandle) return null;
    return quantity === 2 ? 'FLAWLESS2' : quantity === 3 ? 'FLAWLESS3' : null;
  }
  function bundleTotal(quantity) {
    return quantity === 1 ? 1799 : quantity === 2 ? 2999 : quantity === 3 ? 4199 : null;
  }
  function checkoutUrl(raw) {
    const url = new URL(raw);
    if (url.protocol !== 'https:') throw new Error('Invalid Shopify checkout address.');
    url.searchParams.set('channel', 'online_store');
    return url.toString();
  }
  const rules = { flawlessHandle, discountFor, bundleTotal, checkoutUrl };
  if (typeof module !== 'undefined' && module.exports) module.exports = rules;
  else root.TrendifyCommerceRules = rules;
})(typeof window !== 'undefined' ? window : globalThis);
